<template>
  <div class="layout-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SigninLayout"
}
</script>

<style lang="scss" scoped>
.layout-container {
  // width: 100vw;
  // height: 100vh;
  height: 100%;
  width: 100%;
  background-color: $brand-blue
}
</style>
